import React, { Component }              from 'react';
import { withRouter }                    from 'react-router';
import { connect }                       from 'react-redux';
import { Accordion, Card, Button, Form,
         Alert }                         from 'react-bootstrap';
import PubSub                            from 'pubsub-js';
import { ClipLoader }                    from 'react-spinners';
import { MdError }                       from 'react-icons/md';
import { ConnectConstants }              from '../environment';
import { connectSourcesFetchData }       from '../../../../actions/connect/sources';
import { connectSourcesSaveFetchData }   from '../../../../actions/connect/save';

var apiHost = ConnectConstants.WebApiHost;

class SettingsLanding extends Component {
  constructor(props) {
    super(props);
    this.state   = { 
      id: ''
    };
    
    this.saveSettings = this.saveSettings.bind(this);
    this.subscriber   = this.subscriber.bind(this);
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }
  
  componentDidMount() {
    this.token  = PubSub.subscribe('connect.sources.save', this.subscriber.bind(this));
    this.props.fetchDataSources(apiHost, true);
  }
  
  subscriber(msg, data) {
    if (msg === "connect.sources.save") {
      this.setState({
        id: data.Id
      });
    }
  }
  
  saveSettings(e) {
    e.preventDefault();
    e.stopPropagation();
    var form = new FormData(e.currentTarget);
    if (e.currentTarget.checkValidity() !== false) {
      var source = {
        Id          : form.get('Id'),
        Title       : form.get('Title'),
        Description : form.get('Description'),
        Contact: {
          Title       : form.get('Contact.Title'),
          Href        : form.get('Contact.Href'),
          Phone       : form.get('Contact.Phone'),
          TimeEnabled : form.get('Contact.TimeEnabled'),
          StartTime   : form.get('Contact.StartTime'),
          EndTime     : form.get('Contact.EndTime'),
          TimeDays    : form.get('Contact.TimeDays')
        },
        Offline: {
          Message               : form.get('Offline.Message'),
          Email                 : form.get('Offline.Email'),
          CanBeContactedOffline : form.get('Offline.CanBeContactedOffline')
        }
      };
      
      this.props.fetchDataSourcesSave(apiHost, source);
    }
  }

  render() {
    let content = null;
    var panels = [];
    if (this.props.connectSources.Sources) {
      for (var i = 0; i < this.props.connectSources.Sources.length; i++) {
        var p = this.props.connectSources.Sources[i];
          
        panels.push(
          <Accordion key={p.Id}>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey={p.Id}>
                  {p.Title}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey={p.Id}>
                <Card.Body>
                  <Form onSubmit={this.saveSettings}>
                    <Form.Group>
                      <Form.Label>Card Title</Form.Label>
                      <Form.Control name="Title" type="text" placeholder="Card Title" defaultValue={p.Title} required />
                      <span className="text">
                        This field shows up in the card title.
                      </span> 
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Card Description</Form.Label>
                      <Form.Control name="Description" as="textarea" rows="3" defaultValue={p.Description} required />
                      <span className="text">
                        This field shows up in the card description used to open chat.
                      </span>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Card Contact Title</Form.Label>
                      <Form.Control name="Contact.Title" type="text" placeholder="Card Contact Title" defaultValue={p.Contact ? p.Contact.Title : ''} />
                      <span className="text">
                        This title replaces the Online title in the card footer.
                      </span>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Card Contact Link</Form.Label>
                      <Form.Control name="Contact.Href" type="text" placeholder="Card Contact Link" defaultValue={p.Contact ? p.Contact.Href : ''} />
                      <span className="text">
                        This field adds a clickable link to the new card title.
                      </span>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Card Contact Phone</Form.Label>
                      <Form.Control name="Contact.Phone" type="text" placeholder="Card Contact Phone" defaultValue={p.Contact ? p.Contact.Phone : ''} />
                      <span className="text">
                        This field adds a clickable phone number to the new card title next to the clickable title.
                      </span>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Card Offline Start Time</Form.Label>
                      <Form.Control name="Contact.StartTime" as="select" defaultValue={p.Contact && p.Contact.StartTime ? p.Contact.StartTime : "-1"}>
                        <option value="-1">-- Please Choose a Time --</option>
                        <option value="0">12am</option>
                        <option value="1">1am</option>
                        <option value="2">2am</option>
                        <option value="3">3am</option>
                        <option value="4">4am</option>
                        <option value="5">5am</option>
                        <option value="6">6am</option>
                        <option value="7">7am</option>
                        <option value="8">8am</option>
                        <option value="9">9am</option>
                        <option value="10">10am</option>
                        <option value="11">11am</option>
                        <option value="12">12pm</option>
                        <option value="13">1pm</option>
                        <option value="14">2pm</option>
                        <option value="15">3pm</option>
                        <option value="16">4pm</option>
                        <option value="17">5pm</option>
                        <option value="18">6pm</option>
                        <option value="19">7pm</option>
                        <option value="20">8pm</option>
                        <option value="21">9pm</option>
                        <option value="22">10pm</option>
                        <option value="23">11pm</option>
                      </Form.Control>
                      <span className="text">
                        If Enable Automatic Card Offline is true, the chat will become available after the Card Offline Start Time and becomes unavailable after Card Offline Start Time.
                      </span>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Card Offline End Time</Form.Label>
                      <Form.Control name="Contact.EndTime" as="select" defaultValue={p.Contact && p.Contact.EndTime ? p.Contact.EndTime : "-1"}>
                        <option value="-1">-- Please Choose a Time --</option>
                        <option value="0">12am</option>
                        <option value="1">1am</option>
                        <option value="2">2am</option>
                        <option value="3">3am</option>
                        <option value="4">4am</option>
                        <option value="5">5am</option>
                        <option value="6">6am</option>
                        <option value="7">7am</option>
                        <option value="8">8am</option>
                        <option value="9">9am</option>
                        <option value="10">10am</option>
                        <option value="11">11am</option>
                        <option value="12">12pm</option>
                        <option value="13">1pm</option>
                        <option value="14">2pm</option>
                        <option value="15">3pm</option>
                        <option value="16">4pm</option>
                        <option value="17">5pm</option>
                        <option value="18">6pm</option>
                        <option value="19">7pm</option>
                        <option value="20">8pm</option>
                        <option value="21">9pm</option>
                        <option value="22">10pm</option>
                        <option value="23">11pm</option>
                      </Form.Control>
                      <span className="text">
                        If Enable Automatic Card Offline is true, the chat will become available after the Card Offline Start Time and becomes unavailable after Card Offline End Time.
                      </span>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Card Offline Days</Form.Label>
                      <Form.Control name="Contact.TimeDays" as="select" defaultValue={p.Contact && p.Contact.TimeDays ? p.Contact.TimeDays : "-1"}>
                        <option value="-1">-- Please Choose a Day Range --</option>
                        <option value="1">Monday</option>
                        <option value="2">Monday - Tuesday</option>
                        <option value="3">Monday - Wednesday</option>
                        <option value="4">Monday - Thursday</option>
                        <option value="5">Monday - Friday</option>
                        <option value="6">Monday - Saturday</option>
                        <option value="7">7 Days a Week</option>
                      </Form.Control>
                      <span className="text">
                        If Enable Automatic Card Offline is true, the chat will become available only on the day range specified.
                      </span>
                    </Form.Group>
                    <Form.Check style={{ marginBottom: '10px' }} name="Contact.TimeEnabled" type="checkbox" label="Enable Automatic Card Offline?" defaultChecked={p.Contact && p.Contact.TimeEnabled === true ? true : false } />
                    <Form.Group>
                      <Form.Label>Chat Offline Message</Form.Label>
                      <Form.Control name="Offline.Message" as="textarea" rows="3" placeholder="Chat Offline Message" defaultValue={p.Offline ? p.Offline.Message : ''} />
                      <span className="text">
                        This is the message the user sees if the current chat is unavailable. This is a good opportunity to put alternative contact information.
                      </span>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Chat Offline Email</Form.Label>
                      <Form.Control name="Offline.Email" type="text" placeholder="Chat Offline Email" defaultValue={p.Offline ? p.Offline.Email : ''} />
                      <span className="text">
                        This is the email address offline messages are sent to (if online messages are enabled).
                      </span>
                    </Form.Group>
                    <Form.Check name="Offline.CanBeContactedOffline" type="checkbox" label="Enable offline messages?" defaultChecked={p.Offline && p.Offline.CanBeContactedOffline === true ? true : false } />
                    <input type="hidden" name="Id" value={p.Id} />
                    { this.props.sourcesSaveIsLoading ?
                      <ClipLoader
                        color={'#072659'} 
                        loading={this.props.sourcesSaveIsLoading} 
                      />
                      :
                      <button type='submit' className="c-btn c-btn--sm" style={{ width: '100%', lineHeight: 0, marginTop: '10px', marginBottom: '10px' }}>
                        <span className="c-btn__text">Save Changes</span>
                      </button>
                    }
                    { p.Id === this.state.id ?
                      <Alert variant={'success'}>
                        Settings Successfully Saved!
                      </Alert>
                      :
                      <span></span>
                    }
                  </Form>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        );
      }
    }

    if (this.props.connectSources.Sources && this.props.connectSources.Sources.length === 0 && !this.props.sourcesIsLoading) {
      content = 
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          <button title='No results'><MdError size={48} color='orange' /></button>
        </div>;
    }
    else {
      content = 
        <div>
          {panels}
        </div>;
    }

    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.sourcesIsLoading ?
            <ClipLoader
              color={'#072659'} 
              loading={this.props.sourcesIsLoading} 
            />
            : <span />
          }
        </div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    connectSources: state.connect.connectSources.connectSources,
    sourcesHasErrored: state.connect.connectSources.connectSourcesHasErrored,
    sourcesIsLoading: state.connect.connectSources.connectSourcesIsLoading,
    connectSourcesSave: state.connect.connectSourcesSave.connectSourcesSave,
    sourcesSaveHasErrored: state.connect.connectSourcesSave.connectSourcesSaveHasErrored,
    sourcesSaveIsLoading: state.connect.connectSourcesSave.connectSourcesSaveIsLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataSources:     (host, me)   => dispatch(connectSourcesFetchData(host, me)),
    fetchDataSourcesSave: (host, body) => dispatch(connectSourcesSaveFetchData(host, body))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SettingsLanding));
